



































































import { Component, Vue, Watch } from "vue-property-decorator";
import NavMenu from "@/components/NavMenu.vue";
import GenericDialog from "@/components/GenericDialog.vue";
import GlobalAlerts from "@/components/GlobalAlerts.vue";
import UserMenu from "@/components/UserMenu.vue";
import { LayoutModule } from "@/store/layout";
import UsersAPI from "@/services/users";
import { UserModule } from "@/store/user";
import User from "@/models/user";
import * as VueComponent from "vue";
import LineItemForm from "@/views/Campaigns/Components/LineItemForm.vue";
import LangSelector from "@/components/LangSelector.vue";

@Component({
  components: {
    NavMenu,
    GenericDialog,
    GlobalAlerts,
    UserMenu,
    LineItemForm,
    LangSelector,
  },
})
export default class AdminLayout extends Vue {
  appLogo = require("@/assets/app-logo.png");
  selectedItem = 1;
  items = [
    {
      text: "nav.campaigns.section",
      icon: "mdi-view-dashboard",
      items: [
        { text: "nav.campaigns.new_quote", to: "new-campaign" },
        { text: "nav.campaigns.my_campaigns", to: "my-campaigns" },
        { text: "nav.campaigns.campaigns", to: "campaigns" },
        { text: "nav.campaigns.availability", to: "availability" },
      ],
    },
    {
      text: "nav.companies.section",
      icon: "mdi-briefcase-account",
      items: [
        { text: "nav.companies.section", to: "companies" },
        { text: "nav.companies.contacts", to: "contacts" },
      ],
    },
    {
      text: "nav.sites.section",
      icon: "mdi-web-box",
      to: "sites",
    },
    {
      text: "nav.inventory.section",
      icon: "mdi-monitor-dashboard",
      items: [
        { text: "nav.inventory.ad_sizes", to: "sizes" },
        { text: "nav.inventory.definitions", to: "definitions" },
        { text: "nav.inventory.ad_units", to: "ad_units" },
      ],
      admin: true,
    },
    {
      text: "nav.newsletters.section",
      icon: "mdi-email-fast",
      to: "newsletters",
      admin: true,
    },
    {
      text: "nav.reports.section",
      icon: "mdi-chart-box",
      to: "reports",
    },
    {
      text: "nav.users.section",
      icon: "mdi-account",
      to: "users",
      admin: true,
    },
    {
      text: "nav.settings.section",
      icon: "mdi-cogs",
      to: "settings",
      admin: true,
    },
  ];
  drawer = true;

  created(): void {
    LayoutModule.setContentTitle("test");
    this.getCurrentUser();
  }

  get contentTitle(): string {
    return LayoutModule.getContentTitle;
  }

  get appBarColor(): string {
    return this.$vuetify.theme.themes.light.white as string;
  }

  get textHeaderColor(): string {
    return this.$vuetify.theme.themes.light.textHeader as string;
  }

  get showLoader(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  get rightDrawer(): boolean {
    return LayoutModule.rightDrawerIsVisible;
  }

  set rightDrawer(val: boolean) {
    val ? LayoutModule.showRightDrawer() : LayoutModule.hideRightDrawer();
  }

  get rightDrawerComponent(): VueComponent.Component | null {
    return LayoutModule.rightDrawerComponent;
  }

  get rightDrawerComponentProps(): any {
    return LayoutModule.getRightDrawerComponentProps;
  }

  get breadCrumbs(): { path: string; text: string; disabled: boolean }[] {
    const path = this.$route.path;
    const pathArray =
      path.substr(path.length - 1) === "/"
        ? path.slice(0, -1).split("/")
        : path.split("/");

    const breadcrumbs: { path: string; text: string; disabled: boolean }[] = [];
    pathArray.shift();

    pathArray.forEach((path, idx) => {
      this.$route.matched[idx].path != ""
        ? breadcrumbs.push({
            path: this.$route.matched[idx].path,
            text: this.$route.matched[idx].meta.title || path,
            disabled: false,
          })
        : null;
    });

    breadcrumbs.push({
      path: this.$route.path,
      text: this.$route.meta.title,
      disabled: true,
    });

    return breadcrumbs;
  }

  get admin(): boolean {
    return UserModule.isAdmin;
  }

  async getCurrentUser(): Promise<void> {
    try {
      const current_user: User = await UsersAPI.getCurrentUser();
      UserModule.setCurrentUser(current_user);
      this.$i18n.locale = current_user.lang;
    } catch (e) {
      console.log(e);
    }
  }

  @Watch("rightDrawer")
  cleanRightDrawerData(): void {
    if (!this.rightDrawer) {
      LayoutModule.unsetRightDrawerComponentProps();
      LayoutModule.unsetRightDrawerComponent();
    }
  }
}
